export function exponential(options) {
    const { lb, dw } = options;
    const coefExp = -lb * Math.PI * dw;
    return (i) => Math.exp(coefExp * i);
}
//# sourceMappingURL=exponential.js.map